function cov_1lga84bq4d() {
  var path = "/__w/code/code/js/packages/bricks/src/core/Icon/SpritesheetIcons/LevelsFilled.tsx";
  var hash = "311883ee0d92cea0e04911d8d60d457559b34839";
  var global = new Function("return this")();
  var gcv = "__coverage__";
  var coverageData = {
    path: "/__w/code/code/js/packages/bricks/src/core/Icon/SpritesheetIcons/LevelsFilled.tsx",
    statementMap: {
      "0": {
        start: {
          line: 1,
          column: 53
        },
        end: {
          line: 4,
          column: 1
        }
      }
    },
    fnMap: {},
    branchMap: {},
    s: {
      "0": 0
    },
    f: {},
    b: {},
    _coverageSchema: "1a1c01bbd47fc00a2c39e90264f33305004495a9",
    hash: "311883ee0d92cea0e04911d8d60d457559b34839"
  };
  var coverage = global[gcv] || (global[gcv] = {});
  if (!coverage[path] || coverage[path].hash !== hash) {
    coverage[path] = coverageData;
  }
  var actualCoverage = coverage[path];
  {
    // @ts-ignore
    cov_1lga84bq4d = function () {
      return actualCoverage;
    };
  }
  return actualCoverage;
}
cov_1lga84bq4d();
var Icon = (cov_1lga84bq4d().s[0]++, {
  name: 'levels-filled',
  svg: "<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M21.5735 8.70143C21.8408 8.88855 22 9.19434 22 9.52066V13C22 13.5523 21.5523 14 21 14H3C2.44772 14 2 13.5523 2 13V9.52066C2 9.19434 2.15921 8.88855 2.42654 8.70143L11.4265 2.40143C11.7709 2.1604 12.2291 2.1604 12.5735 2.40143L21.5735 8.70143ZM2 17C2 16.4477 2.44772 16 3 16H21C21.5523 16 22 16.4477 22 17V21C22 21.5523 21.5523 22 21 22H3C2.44772 22 2 21.5523 2 21V17Z\" fill=\"currentColor\"/>"
});
export default Icon;